import type { PanGesture } from "react-native-gesture-handler";

export const configureHorizontalCarouselPanGesture = (gesture: PanGesture) => {
  "worklet";
  gesture.activeOffsetX([-10, 10]).failOffsetY([-10, 10]);
  gesture.config.touchAction = "pan-y";
};
